import React from 'react';
import './AdminUserScreen.scss';
import Header from '../Header/header';
// import { Redirect } from 'react-router-dom';
import { auth as AuthObject } from '../../services/login';
import checkAuth from '../../services/checkAuth';
import Footer from '../../containers/Footer/footer';
import withRouter from '../withRouter';

class AdminUserScreen extends React.Component  {
    
    componentDidMount = () => {
        var elem = document.getElementById("as");
        elem.classList.add("active");

    }

    validate = () => {
        var e = document.getElementById("emai").value;
        var atposition = e.indexOf("@");
        var dotposition = e.lastIndexOf(".");


        if (e.length == "") {
            document.getElementById("ema").innerHTML = "Please fill the email field";

            return false;
        }
        else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= e.length) {

            document.getElementById("ema").innerHTML = "Incorrect Email";
            return false;
        }
        else {
            document.getElementById("finalMessage").innerHTML="Successfully Logged in";
            return true;
        }
    }

    constructor(props){
        super(props);
        // this.checkAuthentication = 0;
    }

    // authCheck = async ( )=>{
    //     this.checkAuthentication = await checkAuth();
    // }

    render(){
        
        // this.authCheck();

        // if (!this.checkAuthentication) {
        //     console.log("value of checkaauth not logiin: ", this.checkAuthentication);
            
        //     // return <Redirect to={'/login'} />
        // }
        // else{
        //     console.log("value of checkaauth: ", this.checkAuthentication);

        // }

        return (
            <div>
                <Header />
    
                <section className="adminUserScreen_header">
                    <div className="wrapper">
                        <h1> Admin User Screen</h1>
    
                        <div className="box-design">
                            <div className="form-group">
                                <label>Email ID:</label>
                                <input type="email" id="emai" className="form_input" placeholder="Enter Email" />
                                <div id="ema"></div>
                            </div>
                            <button type="submit" id="btnSubmit" className="btn-default" onClick={this.validate}>Make this User Admin</button>
                            <div id="finalMessage"></div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        )
    }
    

}

export default withRouter(AdminUserScreen);